import {Component, OnInit, ViewChild} from '@angular/core';
import {NavigationCancel, NavigationEnd, Router} from '@angular/router';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {filter} from 'rxjs/operators';
import {ToastContainerDirective, ToastrService} from "ngx-toastr";
import {HitfluencerUserService} from "./services/user/hitfluencer-user.service";

declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    Location, {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    }
  ]
})
export class AppComponent implements OnInit {
  location: any;
  routerSubscription: any;

  @ViewChild(ToastContainerDirective, {static: true}) toastNotification!: ToastContainerDirective;

  constructor(private toastr: ToastrService,
              protected userService: HitfluencerUserService,
              private router: Router) {
    if (this.toastNotification) {
      this.toastr.overlayContainer = this.toastNotification;
    }
  }

  ngOnInit() {
    this.userService.controlUser();
    this.recallJsFuntions();
  }

  recallJsFuntions() {
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
      .subscribe(event => {
        this.location = this.router.url;
        if (!(event instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0);
      });
  }
}
